import { Combobox } from "@insights/ui";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router";
import { buildDefaultWorkspacePath } from "./workspaceNavigation";

export type Workspace = { id: string; name: string };

export function WorkspaceMenu({
  workspaces,
  active,
}: {
  workspaces: Workspace[];
  active: string | undefined;
}) {
  const navigate = useNavigate();
  const current = workspaces.find((workspace) => workspace.id === active);
  const createWorkspaceValue = "workspace-action:create";
  const options = [
    ...workspaces.map((workspace) => ({
      label: workspace.name,
      value: workspace.id,
    })),
    {
      color: "accent" as const,
      icon: Plus,
      label: "Create workspace",
      value: createWorkspaceValue,
    },
  ];

  return (
    <div className="workspace-menu">
      <Combobox
        label="Workspace"
        onValueChange={(value) => {
          navigate(
            value === createWorkspaceValue
              ? "/workspaces/new"
              : buildDefaultWorkspacePath(value),
          );
        }}
        options={options}
        placeholder="Select workspace"
        {...(current ? { value: current.id } : {})}
      />
    </div>
  );
}
